import React, { useEffect, useState } from 'react';
import apiClient from '../../api/apiClient';
import Header from '../../pages/common/Header';
import Footer from '../../pages/common/Footer';

const FrontendPageStatusGate = ({ pageKey, children }) => {
    const [status, setStatus] = useState('unknown');

    useEffect(() => {
        let mounted = true;

        apiClient.get(`/web-pages/frontend-pages/status/${pageKey}`)
            .then((response) => {
                if (!mounted) return;
                setStatus(response.data?.data?.status || 'active');
            })
            .catch(() => {
                if (mounted) setStatus('active');
            });

        return () => {
            mounted = false;
        };
    }, [pageKey]);

    if (status === 'inactive') {
        return (
            <div>
                <Header />
                <main className="container py-5 text-center" style={{ minHeight: '50vh' }}>
                    <h1 className="font-weight-bold mb-3">Page is currently unavailable</h1>
                    <p className="text-muted mb-0">Please check back later.</p>
                </main>
                <Footer />
            </div>
        );
    }

    return children;
};

export default FrontendPageStatusGate;
